import ChatLayout from './ChatLayout';

export default ChatLayout;
